import _styled from "styled-components";
import React from "react";
import { Link } from "~/features/ui/link";
import { Button } from "~/features/ui/button";
import { isLinkValid } from "~/features/ui/link/utils";
import ArrowRight from "~/public/icons/arrow-right.svg";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
export type CtaPairLink = Record<string, unknown> & {
  href?: string;
  newWindow?: boolean;
  text?: React.ReactNode;
};
function linkIcon(link?: CtaPairLink | null) {
  if (!link) {
    return undefined;
  }
  return link.newWindow ? ArrowTopRight : ArrowRight;
}
export type CtaButtonPairProps = {
  primary?: CtaPairLink | null;
  secondary?: CtaPairLink | null;
  className?: string;
};

/**
 * The UI 3.0 CTA button pair: a `solid` primary + an `outline` secondary,
 * both rendered as links. Either link may be omitted; the component renders
 * nothing when neither resolves. `outline`/`ghost` variants inherit the
 * section's `data-theme`, so the pair works in light and dark automatically.
 */
export function CtaButtonPair({
  primary,
  secondary,
  className
}: CtaButtonPairProps) {
  const hasPrimary = isLinkValid(primary);
  const hasSecondary = isLinkValid(secondary);
  if (!hasPrimary && !hasSecondary) {
    return null;
  }
  return <_StyledDiv className={className} $_css={[{
    "display": "flex",
    "flexWrap": "wrap",
    "alignItems": "center",
    "gap": "var(--spacing-md)"
  }]}>
      {hasPrimary && <Button as={Link} {...primary} icon={linkIcon(primary)} variant="solid" />}
      {hasSecondary && <Button as={Link} {...secondary} icon={linkIcon(secondary)} variant="outline" />}
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cta-button-pair___StyledDiv",
  componentId: "sc-1vwu17v-0"
})(["", ""], p => p.$_css);